import { useEffect, useState } from "react";
import { Download, Receipt } from "lucide-react";
import { Button } from "@/components/ui/button";
import { clientApi } from "@/lib/api";
import { toast } from "sonner";

const STATUS = {
  draft: { label: "Brouillon", color: "bg-gray-100 text-gray-700" },
  sent: { label: "À régler", color: "bg-orange-100 text-orange-700" },
  paid: { label: "Payée", color: "bg-green-100 text-green-700" },
};

export default function ClientInvoices() {
  const [invoices, setInvoices] = useState([]);

  useEffect(() => { clientApi.get("/client/invoices").then(({ data }) => setInvoices(data)); }, []);

  const downloadPdf = async (inv) => {
    try {
      const res = await clientApi.get(`/client/invoices/${inv.id}/pdf`, { responseType: "blob" });
      const url = window.URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${inv.number}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch { toast.error("Erreur téléchargement"); }
  };

  return (
    <div className="space-y-6" data-testid="client-invoices">
      <h1 className="font-heading font-black text-3xl text-[#0B1F3A]">Mes factures</h1>
      <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#F5F7FA] text-left">
            <tr>
              <th className="p-3">N°</th><th className="p-3">Projet</th><th className="p-3">Émise</th>
              <th className="p-3">Échéance</th><th className="p-3">Total</th><th className="p-3">Statut</th><th className="p-3 text-right"></th>
            </tr>
          </thead>
          <tbody>
            {invoices.length === 0 && (
              <tr><td colSpan={7} className="p-12 text-center text-[#4B5563]">
                <Receipt className="h-10 w-10 text-gray-300 mx-auto mb-2" /> Aucune facture pour l'instant.
              </td></tr>
            )}
            {invoices.map((inv) => {
              const st = STATUS[inv.status] || STATUS.draft;
              return (
                <tr key={inv.id} className="border-t border-gray-100" data-testid={`portal-invoice-${inv.number}`}>
                  <td className="p-3 font-mono font-bold text-[#0B1F3A]">{inv.number}</td>
                  <td className="p-3 text-[#4B5563]">{inv.project || "—"}</td>
                  <td className="p-3 text-[#4B5563]">{inv.issue_date}</td>
                  <td className="p-3 text-[#4B5563]">{inv.due_date}</td>
                  <td className="p-3 font-bold text-[#0B1F3A]">{(inv.total || 0).toLocaleString("fr-CA", { minimumFractionDigits: 2 })} $</td>
                  <td className="p-3"><span className={`text-xs font-semibold px-2 py-1 rounded-full ${st.color}`}>{st.label}</span></td>
                  <td className="p-3 text-right">
                    <Button size="sm" variant="outline" onClick={() => downloadPdf(inv)} data-testid={`portal-pdf-${inv.number}`}>
                      <Download className="h-4 w-4 mr-1" /> PDF
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
